import type { AnimationControls, Variants } from 'framer-motion';
import { motion } from 'framer-motion';

import { type AnimatedIconHandle, withAnimatedIcon } from './withAnimatedIcon';

type ChartLineIconRenderProps = {
  controls: AnimationControls;
  size: number;
};

const variants: Variants = {
  normal: {
    pathLength: 1,
    opacity: 1,
  },
  animate: {
    pathLength: [0, 1],
    opacity: [0, 1],
    transition: {
      delay: 0.15,
      duration: 0.3,
      opacity: { delay: 0.1 },
    },
  },
};

const ChartLineIconRender = ({ controls, size }: ChartLineIconRenderProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 3v16a2 2 0 0 0 2 2h16" />
    <motion.path d="m7 13 3-3 4 4 5-5" variants={variants} animate={controls} />
  </svg>
);

export type ChartLineIconHandle = AnimatedIconHandle;

export const ChartLineIcon = withAnimatedIcon(ChartLineIconRender, 'ChartLineIcon');
